import Link from "next/link";
import React from "react";
// import './style.scss'

const Leadership = ({ leaders }) => {
  return (
    <div className="main-container">
      <div className="headings">Leadership</div>
      {leaders?.map((data) => (
        <div className="leader-container" key={data.id}>
          <div className="image-container">
            <img
              src={`${process.env.CMS_API_ORIGIN}${data?.picture.url}`}
              alt={data.position}
            />
          </div>

          <div className="discription">
            <h3>{data.name}</h3>
            <h6>{data.position}</h6>
            <p>{data.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Leadership;
